import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
  private baseUrl = environment.BACKEND_URL;
  constructor(private loader: LoaderService) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token = localStorage.getItem('authToken');
    if (token != null) {
      req = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });
    }
    // return next.handle(req);
    if (req.url.endsWith('pen') || req.url.endsWith('key-rotation') || req.url.endsWith('ssl-chat') || req.url.endsWith('ssl') || req.url.endsWith('stripe') || req.url.endsWith('pen-test')) {
      return next.handle(req);
    } else {
      this.loader.showLoader();

      return next.handle(req).pipe(
        finalize(() => {
          this.loader.hideLoader();
        })
      );
    }
  }
}
